export function isValidMail(email) {
    if (!email) return false;
    if (email.length === 0) {
        return false;
      }
      let re = new RegExp(
        "^[\\w!#$%&’*+/=?`{|}~^-]+(?:\\.[\\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$"
      );
      if (re.test(email) === false) {
        return false;
      }
      return true;
}

export function isValidTel(telInput) {
    if(!telInput) return false;
    if (telInput.length === 0) {
      return false
    }
    let re = new RegExp("^[0-9 +-]+$")
    if (re.test(telInput) === false) {
      return false
    }
    return true
}

export function isValidName(name) {
    if(!name) return false;
    if (name.length === 0) {
      return false
    } else {
      return true
    }
}